import { useQueryClient } from '@tanstack/react-query'

import { useDisableUser as useDisableUserHook } from '@/core/hooks/useUser'

interface DisableUserOptions {
	onSuccess?: () => void
	onError?: (error: any) => void
}

export const useDisableUser = () => {
	const queryClient = useQueryClient()

	const disableUserMutation = useDisableUserHook({
		options: {
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: ['users'] })
			},
		},
	})

	const disableUser = (userId: number, options?: DisableUserOptions) => {
		disableUserMutation.mutate(userId, {
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: ['users'] })
				options?.onSuccess?.()
			},
			onError: (error) => {
				options?.onError?.(error)
			},
		})
	}

	return {
		disableUser,
		isDisabling: disableUserMutation.isPending,
		error: disableUserMutation.error,
	}
}
